// extracted by mini-css-extract-plugin
module.exports = {"tooltip_wrapper":"SaveChangesButton_tooltip_wrapper__37CKb","tooltip":"SaveChangesButton_tooltip__2EZpm"};